import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Timeline, Icon, message } from 'antd';
import { apis } from '../api/index.js';

class History extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    form: PropTypes.object,
    history: PropTypes.object,
    reportInfo: PropTypes.object,
  };

  state = {
    confirmLoading: false,
    status: 0,
    operateList: [],
  };
  componentDidUpdate(prevProps) {
    const { visible } = this.props;
    if (prevProps.visible !== visible && visible) this.getOperationRecord();
  }

  //获取操作记录
  getOperationRecord = () => {
    const { reportInfo } = this.props;
    const { diagId } = reportInfo;
    apis.operationRecord(diagId).then(res => {
      if (res.code === '0') {
        this.setState({ operateList: res.data || [] });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = () => {
    this.props.onCancel(false);
  };

  render() {
    let { operateList } = this.state;
    const { visible } = this.props;
    return (
      <div className="group-modal">
        <Modal
          title="操作记录"
          visible={visible}
          width={'50%'}
          height={'60%'}
          ref={this.modal}
          id="modal"
          className="group-manager"
          onCancel={this.handleCancel}
          centered={true}
          keyboard={false}
          maskClosable={false}
          footer={null}
        >
          <div className="report-modal-alert-content report-modal-progress">
            <Timeline>
              {operateList.map((item, index) => {
                return (
                  <Timeline.Item
                    dot={<Icon type="clock-circle" theme="filled" />}
                    key={index}
                    color="blue"
                  >
                    <p>{item.createTime}</p>
                    <p>
                      {item.signature} {item.actionDescription}
                    </p>
                  </Timeline.Item>
                );
              })}
            </Timeline>
          </div>
        </Modal>
      </div>
    );
  }
}

export default History;
